module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "droppable",
    staticClass: "droppable",
    class: {
      dragover: _vm.dragover
    },
    on: {
      "drop": function($event) {
        $event.stopPropagation();
        _vm.dragover = false;
        _vm.$emit('drag-drop', _vm.getData($event))
      },
      "dragover": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.checkBubbling($event)
      },
      "dragenter": function($event) {
        $event.stopPropagation();
        _vm.checkBubbling($event, 'drag-enter')
      },
      "dragleave": function($event) {
        _vm.dragover = false;
        _vm.$emit('drag-leave', _vm.getData($event))
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-501943d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Droppable.vue
// module id = 257
// module chunks = 1